export const biografiaSections = [
  {
    id: 'anni-80-90',
    title: "Anni '80–'90: primi anni e grandi indagini",
    paragraphs: [
      "Arruolato nell'Arma nel 1982, inizia a operare nel Nord Barese in anni segnati da estorsioni e regolamenti di conti mafiosi.",
      {
        strong: "Ottobre 1996 – Cattura dei quattro latitanti della \"banda di Pescara\":",
        rest: " partecipa all'arresto, in un appartamento alla Fiumara (foce dell'Ofanto), di quattro latitanti che un mese prima, il 16 settembre 1996, avevano ucciso a Pescara il maresciallo dei Carabinieri Marino Di Resta durante una rapina a un rappresentante di gioielli.",
      },
    ],
  },
  {
    id: 'fieramosca',
    title: '2001 – Operazione "Fieramosca"',
    paragraphs: [
      "Tra i protagonisti dell'operazione \"Fieramosca\", che assesta un duro colpo al clan Cannito–Lattanzio nel Nord Barese, in un contesto di estorsioni a tappeto e violenze mafiose.",
    ],
  },
  {
    id: 'grandi-rapine',
    title: 'Primi anni 2000 – Grandi rapine e sequestri',
    paragraphs: [
      { strong: '2005 – Operazioni "Download" e "Commando":', rest: '' },
      '"Commando" porta allo smantellamento di un\'organizzazione mafiosa composta da frange criminali calabresi, canosine, cerignolane e foggiane, specializzata in rapine a furgoni portavalori.',
    ],
  },
  {
    id: 'graziella-mansi',
    title: 'Caso Graziella Mansi',
    paragraphs: [
      'Partecipa alle indagini sul caso della piccola Graziella Mansi, bambina trovata brutalmente uccisa; lui stesso ricorda il ritrovamento del corpo come uno degli episodi più traumatici della propria carriera.',
    ],
  },
  {
    id: 'anni-2010',
    title: 'Anni 2010 – Furti di carburante, armi, droga',
    paragraphs: [
      {
        strong: '2013 – Operazione "Predator":',
        rest: " 11 arresti ad Andria per furti di grandi quantitativi di gasolio in depositi del Nord Italia, rivenduto poi nel territorio tramite ricettatori locali.",
      },
      "In un'altra operazione, lui e i suoi uomini individuano a Roma, in via Casilina, un gruppo criminale con annesso deposito di armi.",
    ],
  },
  {
    id: 'sistema-trani',
    title: '2015–2019 – Processo "Sistema Trani"',
    paragraphs: [
      'Dal 2015 coordina, con la Sezione Operativa di Barletta, le indagini che daranno origine al procedimento noto come "Sistema Trani".',
      "Attraverso attentati dinamitardi a un imprenditore foggiano e successive intercettazioni, emergono le figure dell'imprenditore Flavio D'Introno e dei magistrati Michele Nardi e Antonio Savasta e Luigi Scimé al centro di un presunto sistema di corruzione e pilotaggio di procedimenti giudiziari.",
      'Nel gennaio 2019 queste indagini portano agli arresti e alle successive pesanti condanne di primo grado di Nardi, Savasta, Scimé e del sovrintendente di polizia Vincenzo Di Chiaro.',
    ],
  },
  {
    id: 'san-marco-lamis',
    title: '2017–2018 – Strage di San Marco in Lamis',
    paragraphs: [
      {
        strong: '2018 – Strage di San Marco in Lamis (FG):',
        rest: " i Carabinieri di Barletta, con Santoniccolo, identificano come organizzatore il boss di Manfredonia Saverio Tucci, seguendo il filo di un furto d'auto avvenuto a Trani per procurarsi il veicolo usato per la strage.",
      },
      "Sullo sfondo, le indagini documentano l'asse Gargano–Barletta per lo spaccio di stupefacenti; Tucci verrà poi ucciso ad Amsterdam dal narcotrafficante Carlo Magno, successivamente collaboratore di giustizia.",
    ],
  },
  {
    id: 'nabucodonosor',
    title: '2019 – Operazione "Nabucodonosor"',
    paragraphs: [
      {
        strong: 'Operazione "Nabucodonosor" (2019):',
        rest: ' 25 arresti tra capi e gregari di tre organizzazioni criminali eredi del clan Cannito–Lattanzio, attive nel traffico e spaccio di droga sulla piazza di Barletta.',
      },
      "Sempre nel 2019 viene eseguito l'arresto di 25 persone di Andria e Cerignola, accusate di associazione per delinquere finalizzata a furti d'auto, rapine e riciclaggio.",
    ],
  },
];

export const puntiEssenziali = [
  "È andriese di nascita e barlettano d'adozione.",
  "Si è arruolato nell'Arma nel 1982 e ha svolto 41 anni di servizio.",
  'È stato Comandante della Sezione Operativa della Compagnia Carabinieri di Barletta fino al 12 maggio 2023, quando è andato in pensione per raggiunti limiti di età.',
  'Ha guidato o contribuito a numerose indagini complesse contro criminalità organizzata, rapinatori e latitanti nel Nord Barese.',
  'Ha condotto le indagini su "Sistema Trani", che nel 2019 portarono agli arresti e alle pesanti condanne in primo grado degli ex magistrati Michele Nardi e Antonio Savasta e di un sovrintendente di polizia.',
];

export const riconoscimenti = [
  'Dal 2019 è formalmente Comandante della Sezione Operativa della Compagnia Carabinieri di Barletta.',
  'Nel corso della carriera gli vengono riconosciuti 15 encomi per meritoria attività investigativa da parte di varie autorità giudiziarie e numerosi premi civili.',
  "È insignito dell'Onorificenza di Cavaliere al Merito della Repubblica Italiana dal Presidente della Repubblica Sergio Mattarella.",
  "Va in congedo per limiti di età dopo 41 anni di servizio, lasciando l'Arma come luogotenente \"carica speciale\" e considerato uno degli investigatori simbolo del territorio Barletta–Andria–Trani.",
];

export const fonti = [
  {
    url: 'https://www.lagazzettadelmezzogiorno.it/news/bat/1231301/giustizia-svendita-a-trani-parla-il-carabiniere-da-cui-partirono-le-indagini.html',
    label: 'La Gazzetta del Mezzogiorno - Giustizia svendita a Trani',
  },
  {
    url: 'https://www.lagazzettadelmezzogiorno.it/news/bat/1400232/barletta-storia-di-un-investigatore-davvero-speciale.html',
    label: 'La Gazzetta del Mezzogiorno - Storia di un investigatore',
  },
  {
    url: 'https://ilquartopotere.it/sistema-trani/giustizia-svenduta-ascoltato-saverio-santoniccolo-il-carabiniere-che-ha-condotto-le-indagini-su-sistema-trani/',
    label: 'Il Quarto Potere - Sistema Trani',
  },
  {
    url: 'https://trani.news24.city/2023/05/26/legalita-e-violenza-lintervento-della-consigliera-regionale-debora-ciliento/',
    label: 'Trani News24',
  },
  {
    url: 'https://www.barlettaviva.it/notizie/celebrata-in-prefettura-la-festa-della-repubblica/',
    label: 'BarlettaViva',
  },
  {
    url: 'https://www.traniviva.it/notizie/l-arma-dei-carabinieri-in-festa-ieri-la-cerimonia-provinciale-a-barletta/',
    label: 'TraniViva',
  },
  {
    url: 'https://www.barlettanews24.it/attualita/15416/onorificenze-al-merito-della-repubblica-italiana-la-cerimonia-in-prefettura',
    label: 'BarlettaNews24',
  },
];
